"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrameTitle = void 0;

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var Image_1 = __importDefault(require("../../Icon/Image"));

var Pipe_1 = __importDefault(require("../../Pipe"));

var Base_1 = __importDefault(require("../Base"));

var useStyles_1 = __importDefault(require("./useStyles"));

var IFrameTitle = function IFrameTitle(_a) {
  var icon = _a.icon,
      logo = _a.logo,
      title = _a.title,
      url = _a.url;
  var classes = (0, useStyles_1.default)();
  var imageIcon = logo ? react_1.default.createElement(Image_1.default, {
    name: "Open in New Tab",
    url: logo
  }) : icon;
  return imageIcon ? react_1.default.createElement("div", null, react_1.default.createElement("a", {
    className: classes.a,
    href: url,
    rel: "noreferrer",
    target: "_blank"
  }, imageIcon), ' ', react_1.default.createElement(Pipe_1.default, {
    type: "thin"
  }), ' ', title) : react_1.default.createElement(react_1.default.Fragment, null, title);
};

exports.IFrameTitle = IFrameTitle;
/**
 * General iFrame layout Moment.
 */

var IFrameMoment = function IFrameMoment(props) {
  var icon = props.icon,
      iframe = props.iframe,
      logo = props.logo,
      title = props.title,
      url = props.url;
  var classes = (0, useStyles_1.default)();
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(Base_1.default, __assign({}, props, {
    title: react_1.default.createElement(exports.IFrameTitle, {
      icon: icon,
      logo: logo,
      title: title,
      url: url
    })
  }), react_1.default.createElement("iframe", __assign({
    allowFullScreen: true,
    className: classes.iframe,
    frameBorder: "0",
    height: "100vh",
    src: url,
    title: typeof title === 'string' ? title : url,
    width: "100%"
  }, iframe)));
};

IFrameMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Props to pass through to the iFrame Attributes. */
  // eslint-disable-next-line react/forbid-prop-types
  iframe: prop_types_1.default.object,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string,

  /** The source of the iFrame to render in the `Moment`'s body. */
  url: prop_types_1.default.string.isRequired
};
IFrameMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  color: {
    background: 'gray',
    text: 'white'
  },
  iframe: {},
  layout: constants_1.MomentLayout.IFrame,
  type: constants_1.MomentType.IFrame
});
exports.default = IFrameMoment;